var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M14.952.953a2.675 2.675 0 0 0-1.893-.786h-9.56A2.675 2.675 0 0 0 .832 2.833v21.334a2.663 2.663 0 0 0 2.653 2.666H19.5c1.466 0 2.666-1.2 2.666-2.666V9.273c0-.706-.28-1.386-.786-1.88L14.952.953Zm.547 20.547h-8c-.734 0-1.334-.6-1.334-1.333 0-.734.6-1.334 1.334-1.334h8c.733 0 1.333.6 1.333 1.334 0 .733-.6 1.333-1.333 1.333Zm0-5.333h-8c-.734 0-1.334-.6-1.334-1.334 0-.733.6-1.333 1.334-1.333h8c.733 0 1.333.6 1.333 1.333 0 .734-.6 1.334-1.333 1.334Zm-2.667-8v-6L20.165 9.5h-6c-.733 0-1.333-.6-1.333-1.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.6ae64d4e9a437ddfa6e39803d42d6e3a.svg";
export { ForwardRef as ReactComponent };